// extracted by mini-css-extract-plugin
module.exports = {"declaration":"gXKfo3b2osaGjgaeGqQc5g==","footer":"qO+2rKh2ddN3mYkpmW5nOg=="};